<template>
  <page-template>
    <div class="cart_toolbar">
      <div>시직일</div>
      <datetime
        class="myDateTime"
        type="datetime"
        v-model="beginTime"
        use12-hour
      ></datetime>
      <div class="spacer"></div>
      <div>종료일</div>
      <div class="spacer"></div>
      <datetime class="myDateTime" type="datetime" v-model="endTime"></datetime>
      <button @click="resetDate" class="ui button negative">리셋</button>
      <button @click="onehour">1시간이내</button>
      <button @click="threehour">3시간이내</button>
      <button @click="oneday">24시간이내</button>
      <button @click="oneweek">1주일이내</button>
      <button @click="onemonth">1개월이내</button>
      <button @click="threemonth">3개월이내</button>
    </div>
    <board
      :is-fold="isFold"
      :http-options="httpOptions"
      :config="config"
      :play-button-function="callModalSignupConfirm"
      :disabled-modify-button="true"
      :disabled-delete-button="true"
      :disabled-play-button="true"
      :disabled-search-button="true"
    />
    <iframe id="my_iframe" style="display:none;"></iframe>
  </page-template>
</template>

<script>
import Vue from "vue";
import axios from "axios";

import config from "./Config";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
//Vue.use(Datetime);
// Vue.component("datetime", Datetime);

import CartManagementCustomActionComponent from "./custom-action-component/CartManagementCustomActionComponent";
import CommonBoardItems from "../CommonBoardItems";

import moment from "moment";

Vue.component(
  "CartManagementCustomActionComponent",
  CartManagementCustomActionComponent
);

export default {
  name: "BoardCartsManagement",
  components: {
    Datetime: Datetime
  },
  mounted() {
    this.resetDate();
  },
  methods: {
    resetDate() {
      let now = new Date();
      this.endTime = null;
      this.beginTime = new Date("2017-01-01 00:00:00").toISOString();
      this.endTime = now.toISOString();
    },
    onehour() {
      this.endTime = null;
      let now = new Date();
      this.endTime = now.toISOString();
      now.setHours(now.getHours() - 1);
      this.beginTime = now.toISOString();
    },
    threehour() {
      this.endTime = null;
      let now = new Date();
      this.endTime = now.toISOString();
      now.setHours(now.getHours() - 3);
      this.beginTime = now.toISOString();
    },
    oneday() {
      this.endTime = null;
      let now = new Date();
      this.endTime = now.toISOString();
      now.setHours(now.getHours() - 24);
      this.beginTime = now.toISOString();
    },
    oneweek() {
      this.endTime = null;
      let now = new Date();
      this.endTime = now.toISOString();
      now.setHours(now.getHours() - 24 * 7);
      this.beginTime = now.toISOString();
    },
    onemonth() {
      this.endTime = null;
      let now = new Date();
      this.endTime = now.toISOString();
      now.setMonth(now.getMonth() - 1);
      this.beginTime = now.toISOString();
    },
    threemonth() {
      this.endTime = null;
      let now = new Date();
      this.endTime = now.toISOString();
      now.setMonth(now.getMonth() - 3);
      this.beginTime = now.toISOString();
    },
    getFromServer() {
      if (this.beginTime != null && this.endTime != null) {
        config.apiUrl = `/api/carts_count/?beginTime=${this.beginTime}&endTime=${this.endTime}`;
        console.log("beginTime config.apiUrl", config.apiUrl);
      }
    },
    // async resetFilter() {
    //   this.filterLogicalOperation = "";
    //   this.filterField = "";
    //   this.filterOperator = "=";
    //   this.filterValue = "";
    //   config.apiUrl = "/api/carts";
    //   this.$events.fire("filter-set");
    // },
    // async filter() {
    //   if (this.cannotFilter) return;
    //   console.log("filterLogicalOperation", this.filterLogicalOperation);
    //   console.log("filterField", this.filterField);
    //   console.log("filterOperator", this.filterOperator);
    //   console.log("filterValue", this.filterValue);

    //   let myOptions = JSON.parse(JSON.stringify(this.httpOptions));
    //   delete myOptions.params;
    //   console.log(this.httpOptions);
    //   let filter = [
    //     {
    //       field: this.filterField,
    //       operator: this.filterOperator,
    //       value: this.filterValue
    //     }
    //   ];
    //   this.$events.fire("filter-set", JSON.stringify(filter));
    //   config.apiUrl = "/api/carts-filter";
    // },
    async exportCSV() {
      console.dir(this.httpOptions);
      let myOptions = JSON.parse(JSON.stringify(this.httpOptions));
      delete myOptions.params.per_page;
      const response = await axios.get(
        "/api/cart/terms_noti_sms/true?per_page=all",
        myOptions
      );
      console.log("response", response);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", response.headers.filename);
      document.body.appendChild(link);
      link.click();
    },
    callModalSignupConfirm(rowData) {
      this.$modal.changeToComponent(
        this.$modal.modalType.SignupConfirm,
        rowData
      );
    }
  },
  mixins: [CommonBoardItems],
  data() {
    return {
      beginTime: null,
      endTime: null,
      config,
      is_ordered: false
    };
  },
  computed: {
    cannotFilter() {
      return true;
    }
  },
  watch: {
    beginTime: function(val) {
      this.getFromServer();
    },
    endTime: function(val) {
      this.getFromServer();
    }
    // endTime: value => {
    //   this.getFromServer();
    //   // let beginTimeVal = this.beginTime;
    //   // let endTimeVal = value;
    //   // if (beginTimeVal != null && endTimeVal != null) {
    //   //   config.apiUrl = `/api/carts_count/?beginTime=${beginTimeVal}&endTime=${endTimeVal}`;
    //   //   console.log("beginTime config.apiUrl", config.apiUrl);
    //   // }
    // }
  }
};
</script>

<style>
.cart_toolbar {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
}
.wpusers_toolbar > input,
button {
  margin-left: 20px;
}
.wpusers_toolbar > label {
  margin-left: 6px;
}

.spacer {
  min-width: 10px;
}

.myDateTime {
  width: 200px;
}

.myDateTime input {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/carts-management/BoardCartsManagement.vue